import React, { useEffect } from "react";
import { OwcButton } from "@one/react";
import { ConfirmDialogReason } from "../../../../components/shared/ConfirmDialogReason";
import CreateFieldStyled from "../CreateFieldStyled";

const DeleteModalDialog = ({ open, onCancel, deleteModalAccordion, disableModalAccordion, setDisableModalAccordion}) => {
  useEffect(() => {
    setDisableModalAccordion(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ConfirmDialogReason
      open={open}
      close={onCancel}
      approveText={"Delete"}
      approveColor="primary"
      approveVariant="primary"
      cancelText="Cancel"
      cancelVariant="outlined"
      cancelColor="primary"
      onCancel={onCancel}
      testid={"import-file-dialog"}
      title={"Delete booking restriction"}
      renderActions={({ cancelText, approveText }) => (
        <div style={{ paddingBottom: 8, display: "flex" }}>
          <OwcButton
            data-testid="confirm-dialog-actions-button-cancel"
            onClick={onCancel}
            variant="secondary"
            style={{ marginRight: 32 }}
          >
            {cancelText}
          </OwcButton>
          <OwcButton
            data-testid="confirm-dialog-actions-button-approve"
            onClick={() => {
              deleteModalAccordion();
            }}
            variant="primary"
            disabled={disableModalAccordion}
          >
            {approveText}
          </OwcButton>
        </div>
      )}
    >
      <CreateFieldStyled>Are you sure you want to delete this booking restriction?</CreateFieldStyled>
    </ConfirmDialogReason>
  );
};

export default DeleteModalDialog;
